/**
 * Generate a plain initial form state from an array of schema sections.
 * This is service-agnostic and intended for generic forms (e.g., Create CPA).
 *
 * Supported field types and defaults:
 * - input, textarea: ""
 * - single_select: null
 * - multi_select: []
 * - single_boolean_choice: { value: false }
 * - composed_boolean_choice: { status: false, value: 0 }
 * - single_address: top-level address fields initialized
 * - multi_address: [] in the field's key
 */
export function generateGenericFormState({ schemaSections }) {
  const state = {};

  const ensureSingleAddressDefaults = () => {
    if (state.address === undefined) state.address = "";
    if (state.suiteAddress === undefined) state.suiteAddress = "";
    if (state.city === undefined) state.city = "";
    if (state.stateAddress === undefined) state.stateAddress = "Alabama";
    if (state.zipCode === undefined) state.zipCode = "";
    if (state.country === undefined) state.country = "US";
  };

  const sectionsArray = Array.isArray(schemaSections) ? schemaSections : [];

  sectionsArray.forEach((section) => {
    if (!section || !Array.isArray(section.fields)) return;
    section.fields.forEach((field) => {
      const fieldName = field?.name;
      const type = field?.type;
      if (!fieldName || !type) return;

      switch (type) {
        case "input":
        case "textarea":
          state[fieldName] = "";
          break;
        case "single_select":
          state[fieldName] = null;
          break;
        case "multi_select":
          state[fieldName] = [];
          break;
        case "single_boolean_choice":
          state[fieldName] = { value: false };
          break;
        case "composed_boolean_choice":
          state[fieldName] = { status: false, value: 0 };
          break;
        case "single_address":
          ensureSingleAddressDefaults();
          break;
        case "multi_address":
          state[fieldName] = [];
          break;
        default:
          state[fieldName] = null;
      }
    });
  });

  return state;
}

export default generateGenericFormState;
